var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box-style",style:({height:_vm.height})},[_c('designProcess',{attrs:{"selectGroupItem":_vm.selectGroupItem,"heightTwo":_vm.heightTwo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }